import { useSelector } from 'react-redux';
import { ListingDescription } from '@common/Listing/containers/ListingDescription';

export function ListingBottom(props) {
    const { description } = props;
    const { currentPage } = useSelector(({ listing }) => listing.pagination);
    const hasToShowDescription = description && currentPage === 1;

    if (hasToShowDescription) {
        return (
            <ListingDescription
                {...props}
                descriptionId="bottom_desc"
                theme="grey"
            />
        );
    }

    return null;
}
